import { styled } from '@mui/material/styles';
import { AppBar, Box, Typography, Menu } from '@mui/material';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: '#fff',
  color: '#000',
  boxShadow: 'none',
  borderBottom: '1px solid #e0e0e0',
  [theme.breakpoints.down('md')]: {
    paddingTop: 'env(safe-area-inset-top)', // Account for mobile status bar
    minHeight: '64px',
    // iOS Safari PWA specific fixes
    '@supports (-webkit-touch-callout: none)': {
      // iOS Safari specific styles
      paddingTop: 'env(safe-area-inset-top, 0px)', // Account for safe area
    },
    // PWA standalone mode specific styles
    '@media (display-mode: standalone)': {
      paddingTop: 'env(safe-area-inset-top, 0px)', // Account for safe area in PWA
    },
  },
  '& .MuiToolbar-root': {
    [theme.breakpoints.down('md')]: {
      minHeight: '56px', // Slightly smaller on mobile
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

export const UserInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  gap: '8px',
  cursor: 'pointer',
  padding: '4px',
  flexShrink: 0, // Prevent shrinking on mobile
  '&:hover': {
    opacity: 0.9,
  },
  [theme.breakpoints.down('md')]: {
    gap: '6px', // Slightly smaller gap on mobile
  },
}));

export const SystemBanner = styled(Box)({
  backgroundColor: '#2196f3',
  color: 'white',
  padding: '12px',
  textAlign: 'center',
});

export const UserAvatar = styled(Box)({
  backgroundColor: '#2196f3',
  width: '32px',
  height: '32px',
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '14px',
  fontWeight: 500,
});

export const UserTextContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  lineHeight: 1.2,
});

export const UserName = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  color: '#000',
  lineHeight: '16px',
});

export const UserRole = styled(Typography)({
  fontSize: '12px',
  color: '#666',
  lineHeight: '14px',
});

export const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    marginTop: '8px',
    minWidth: '120px',
    boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
  },
});
